import { render } from "./ModalAlert.vue?vue&type=template&id=a6fd8f12&ts=true"
import script from "./ModalAlert.vue?vue&type=script&lang=ts"
export * from "./ModalAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__